var map = {
	"./index.test.browser.js": 221,
	"./store/IndexedDB.test.browser.js": 223
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 222;


//////////////////
// WEBPACK FOOTER
// ./test test\.browser\.js$
// module id = 222
// module chunks = 0